import {
  IonButton,
  IonCol,
  IonContent,
  IonFooter,
  IonGrid,
  IonHeader,
  IonImg,
  IonPage,
  IonRow,
} from "@ionic/react";
import PhoneHeight from "../assets/images/phone-height.png";
import { Link, useHistory } from "react-router-dom";
import tripodtableIcon from "../assets/images/tripod_table.png";
import tabletIcon from "../assets/images/tripod-img.png";
import TopLeftUserName from "../components/TopLeftUserName";
import { useRecoilState } from "recoil";
import { currentAssessmentState } from "../data/atoms";
import { TestType } from "../models/Enums";

const PhoneHeightRequirement: React.FC = () => {
  let history = useHistory();

  const selectedAssessment = sessionStorage.getItem("selectedAssesment");

  return (
    <IonPage placeholder={undefined}>
      <TopLeftUserName headerText="Angle Calibration"></TopLeftUserName>
      <IonContent placeholder={undefined} className="slide-in-right">
        {/* <div className="center-adjustment"> */}
        <IonGrid className="container" placeholder={undefined}>
          <IonRow className="row" placeholder={undefined}>
            <IonCol className="col-sec" placeholder={undefined}>
              <div className="phone-height-requirement-wrap">
                <h2 style={{ paddingBottom: "66px" }}>
                  For best results, mount tablet on the provided tripod at a
                  height of 30 inches.
                </h2>
                <IonImg
                  src={tabletIcon}
                  alt="tripodtableIcon"
                  placeholder={undefined}
                ></IonImg>
              </div>
            </IonCol>
          </IonRow>
        </IonGrid>
        <div style={{ padding: "66px 19px 0px 19px" }}>
          <IonRow className="row" placeholder={undefined}>
            <IonCol className="col-sec" placeholder={undefined}>
              {Number(selectedAssessment) === TestType.gait && (
                <div className="gait-assessment-info-page-inner-wrap">
                  <div className="main-heading assessment-selection-heading">
                    <h1>Gait Analysis</h1>
                    <p className="assessment-new-text">
                      Gait Analysis Setup Instructions
                    </p>
                  </div>
                  <h6 className="gait-info-label">Required:</h6>
                  <ul className="gait-list">
                    <li>Tripod</li>
                    <li>ProactiveStrides Tablet</li>
                    <li>15 feet of space</li>
                    {/* <li>15 feet of space</li> */}
                  </ul>{" "}
                  <h6 className="gait-info-label instruction">Instructions:</h6>
                  <ol type="1">
                    <li>Ensure patient is within the starting box after calibration</li>
                    <li>When ready, therapist should raise 1 arm</li>
                    <li>Walk safely but briskly towards the tablet</li>
                    <li>Assessment will auto stop at finish line</li>
                  </ol>
                </div>
              )}
              {Number(selectedAssessment) === TestType.five_x_sit_stand && (
                <div className="gait-assessment-info-page-inner-wrap">
                  <div className="main-heading assessment-selection-heading">
                    <h1>5 Times Sit-to-Stand</h1>
                    <p className="assessment-new-text">
                      5XSTS Setup Instructions
                    </p>
                  </div>
                  <h6 className="gait-info-label">Required:</h6>
                  <ul className="gait-list">
                    <li>Tripod</li>
                    <li>Standard chair</li>
                    <li>ProactiveStrides Tablet</li>
                    <li>10 feet of space</li>
                  </ul>
                  <h6 className="gait-info-label instruction">Instructions:</h6>
                  <ol type="1">
                    <li>Ensure patient is within the starting box</li>
                    <li>Place chair around 8 feet away from phone</li>
                    <li>
                      Therapist should raise 1 arm to calibrate patient height
                    </li>
                    <li>Begin seated and raise arm to start</li>
                    <li>Stand and sit down 5 times as fast as possible</li>
                  </ol>
                </div>
              )}
              {Number(selectedAssessment) === TestType.upper_body_arom && (
                <div className="gait-assessment-info-page-inner-wrap">
                  <div className="main-heading assessment-selection-heading">
                    <h1>Upper Body AROM</h1>
                    <p className="assessment-new-text">
                      AROM Setup Instructions
                    </p>
                  </div>
                  <h6 className="gait-info-label">Required:</h6>
                  <ul className="gait-list">
                    <li>Tripod</li>
                    <li>ProactiveStrides tablet</li>
                    <li>Chair (Optional)</li>
                  </ul>
                  <h6 className="gait-info-label instruction">Instructions:</h6>
                  <ol type="1">
                    <li>
                      Phase 1
                      <ol type="a">
                        <li>
                          Shoulder Abduction and Adduction with the participant
                          facing the camera
                        </li>
                      </ol>
                    </li>
                    <li>
                      Phase 2
                      <ol type="a">
                        <li>Left Shoulder Flexion & Extension</li>
                        <li>Left Elbow Flexion & Extension</li>
                        <li>Left Shoulder Internal & External Rotation</li>
                      </ol>
                    </li>
                    <li>
                      Phase 3
                      <ol type="a">
                        <li>Right Shoulder Flexion & Extension</li>
                        <li>Right Elbow Flexion & Extension</li>
                        <li>Right Shoulder Internal & External Rotation</li>
                      </ol>
                    </li>
                  </ol>
                </div>
              )}
              {Number(selectedAssessment) === TestType.tug && (
                <div className="gait-assessment-info-page-inner-wrap">
                  <div className="main-heading assessment-selection-heading">
                    <h1>Timed Up and Go</h1>
                    <p className="assessment-new-text">
                      TUG Setup Instructions
                    </p>
                  </div>
                  <h6 className="gait-info-label">Required:</h6>
                  <ul className="gait-list">
                    <li>Tripod</li>
                    <li>ProactiveStrides Tablet</li>
                    <li>Standard armchair (with armrests)</li>
                    <li>~15 feet of clear walking space</li>
                  </ul>
                  <h6 className="gait-info-label instruction">Instructions:</h6>
                  <ol type="1">
                    <li>Mount the iPad securely on the tripod</li>
                    <li>
                      Position the iPad so the{" "}
                      <strong>entire body of the patient is visible</strong>{" "}
                      throughout the assessment, including:
                      <ul>
                        <li>Sitting</li>
                        <li>Standing</li>
                        <li>Walking forward</li>
                        <li>Turning</li>
                        <li>Walking back</li>
                        <li>Sitting down</li>
                      </ul>
                    </li>
                    <li>
                      Place the chair safely behind the patient (chair against a
                      wall if possible)
                    </li>
                    <li>
                      Ensure good lighting and a clutter-free background
                    </li>
                  </ol>
                  <h6 className="gait-info-label instruction">
                    During the Assessment:
                  </h6>
                  <ol type="1">
                    <li>
                      Start the assessment in the Proactive Strides app
                    </li>
                    <li>
                      Once the assessment begins, ask the patient to perform the
                      Timed Up and Go test
                    </li>
                    <li>
                      The assessment will automatically stop when the patient
                      returns to the chair and sits back fully
                    </li>
                  </ol>
                </div>
              )}
              {Number(selectedAssessment) === TestType.ctsib && (
                <div className="gait-assessment-info-page-inner-wrap">
                  <div className="main-heading assessment-selection-heading">
                    <h1>mCTSIB</h1>
                    <p className="assessment-new-text">
                      mCTSIB Instructions
                    </p>
                  </div>
                  <h6 className="gait-info-label">Required:</h6>
                  <ul className="gait-list">
                    <li>Firm floor surface</li>
                    <li>Foam pad (for foam conditions)</li>
                    <li>ProactiveStrides Tablet</li>
                  </ul>
                  <h6 className="gait-info-label instruction">Instructions:</h6>
                  <ol type="1">
                    <li>Mount the iPad securely on the tripod</li>
                    <li>Have the patient stand with feet together</li>
                    <li>Arms at sides, stand as still as possible</li>
                    <li>
                      Follow on-screen prompts for eyes open or closed
                    </li>
                    <li>Each condition runs automatically for 30 seconds</li>
                    <li>Test will auto-stop if balance is lost</li>
                  </ol>
                </div>
              )}
              {Number(selectedAssessment) === TestType.reach && (
                <div className="gait-assessment-info-page-inner-wrap">
                  <div className="main-heading assessment-selection-heading">
                    <h1>Funtional Reach</h1>
                    <p className="assessment-new-text">Setup Instructions</p>
                  </div>
                  <h6 className="gait-info-label">Required:</h6>
                  <ul className="gait-list">
                    <li>Tripod</li>
                    <li>ProactiveStrides tablet</li>
                    {/* <li>Chair (Optional)</li> */}
                  </ul>
                  <h6 className="gait-info-label instruction">Instructions:</h6>
                  <ol type="1">
                    <li>
                      Phase 1
                      <ol type="a">
                        <li>
                          Left reach with the participant facing the camera.
                        </li>
                      </ol>
                    </li>
                    <li>
                      Phase 2
                      <ol type="a">
                        <li>
                          Right reach with the participant facing the camera.
                        </li>
                      </ol>
                    </li>
                    <li>
                      Phase 3
                      <ol type="a">
                        <li>
                          Forward reach with the participant left side facing
                          the camera.
                        </li>
                      </ol>
                    </li>
                  </ol>
                </div>
              )}
            </IonCol>
          </IonRow>
        </div>
      </IonContent>
    </IonPage>
  );
};
export default PhoneHeightRequirement;
